import {
    Feature,
    createActionFactory,
    UnifiedGroup,
    ThunkDispatch,
    createDataActionFactory,
    UnifiedGroupExportStatus,
} from '../../../../shared';
import getUnifiedGroupPrivacyTask from '../../../dataLayer/ows/groups/getUnifiedGroupPrivacyTask';
import createUnifiedGroupPrivacyTask from '../../../dataLayer/ows/groups/createUnifiedGroupPrivacyTask';

export const exportUnifiedGroupClickedAction = createActionFactory<{
    group: UnifiedGroup;
}>('ExportUnifiedGroupClickedAction', Feature.UnifiedGroups);

export const getUnifiedGroupExportStatusCompletedAction = createDataActionFactory<
    {
        hubPersonaId: string;
        status: UnifiedGroupExportStatus;
        link: string;
    },
    { hubPersonaId: string }
>('getUnifiedGroupExportStatusCompletedAction', Feature.UnifiedGroups);

export const createExportUnifiedGroupTaskCompletedAction = createDataActionFactory<
    {
        hubPersonaId: string;
        status: UnifiedGroupExportStatus;
        link: string;
    },
    { hubPersonaId: string }
>('createExportUnifiedGroupTaskCompletedAction', Feature.UnifiedGroups);

export const getExportUnifiedGroupStatus = (
    dispatch: ThunkDispatch,
    groupId: string,
    groupSmtp: string,
    hubPersonaId: string
) =>
    getUnifiedGroupPrivacyTask(groupId, groupSmtp)
        .then(response => {
            const exportStatus: UnifiedGroupExportStatus = getExportStatus(response.Body.Status);
            dispatch(
                getUnifiedGroupExportStatusCompletedAction.success({
                    hubPersonaId,
                    status: exportStatus,
                    link: response.Body.Link,
                })
            );
        })
        .catch((error: Error) => {
            dispatch(
                getUnifiedGroupExportStatusCompletedAction.error({
                    hubPersonaId,
                })
            );
            throw new Error(
                'getUnifiedGroupPrivacyTask_failed : This should be notified to the user'
            );
        });

export const createExportUnifiedGroupTask = (
    dispatch: ThunkDispatch,
    groupId: string,
    groupSmtp: string,
    hubPersonaId: string
) =>
    createUnifiedGroupPrivacyTask(groupId, groupSmtp)
        .then(response => {
            const exportStatus: UnifiedGroupExportStatus = getExportStatus(response.Body.Status);
            dispatch(
                createExportUnifiedGroupTaskCompletedAction.success({
                    hubPersonaId,
                    status: exportStatus,
                    link: response.Body.Link,
                })
            );
        })
        .catch((_error: Error) => {
            dispatch(
                createExportUnifiedGroupTaskCompletedAction.error({
                    hubPersonaId,
                })
            );
            throw new Error(
                'createUnifiedGroupPrivacyTask_failed : This should be notified to the user'
            );
        });

function getExportStatus(responseStatus: string): UnifiedGroupExportStatus {
    switch (responseStatus) {
        case 'NotPresent':
            return UnifiedGroupExportStatus.NotPresent;
        case 'InProgress':
            return UnifiedGroupExportStatus.InProgress;
        case 'Completed':
            return UnifiedGroupExportStatus.Completed;
        case 'Failed':
            return UnifiedGroupExportStatus.Failed;
        default:
            return UnifiedGroupExportStatus.None;
    }
}
